import React from 'react';
import { OptionProps as RsOptionProps, components } from 'react-select';
import { Icon, IconName } from '@shared/components/Icon';
import { FilterTagOption } from '@shared/components/filter/types';
import { Colors, grid } from '@shared/styles';
import staticStyles from './styles.module.css';

export interface OptionProps<T = FilterTagOption> extends RsOptionProps<T> {
  icon?: IconName;
  showCheckbox?: boolean;
  styles: React.CSSProperties;
}
/* custom Option component passed to react-select */
export function Option<T = FilterTagOption>({
  children,
  icon,
  styles = {},
  showCheckbox = true,
  ...props
}: OptionProps<T>) {
  return (
    <components.Option {...props} getStyles={() => ({})}>
      <div className={staticStyles.option} style={styles}>
        <div className={staticStyles.content}>
          {!!icon && (
            <div style={{ marginRight: grid(1) }}>
              <Icon name={icon} color={Colors.v2.purple} gridSize={3} />
            </div>
          )}
          {children}
        </div>
        {showCheckbox && (
          <>
            {props.isSelected && <Icon name="check-box" color={Colors.v2.green} gridSize={3.5} />}
            {!props.isSelected && (
              <Icon name="check-box-empty" color={Colors.v2.green} gridSize={3.5} />
            )}
          </>
        )}
      </div>
    </components.Option>
  );
}
